<div class="emoji-rating-container">
  <button
    type="button"
    class="btn emoji-btn"
    *ngFor="let option of options"
    [class.selected]="isSelected(option.value)"
    (click)="select(option.value)"
  >
    <img [src]="isSelected(option.value) ? option.iconActive : option.icon" [alt]="option.label" class="emoji-icon" />
  </button>
</div>
